import React from "react";

const LoadingIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="50"
      cy="50"
      r="40"
      stroke="white"
      strokeWidth="8"
      strokeLinecap="round"
      strokeDasharray="62.8 62.8"
      strokeDashoffset="0"
      fill="none"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 50 50"
        to="360 50 50"
        dur="1s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="strokeDashoffset"
        values="0;62.8"
        dur="1s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

export default LoadingIcon;